<div class="field-block field-name">
  <div class="simple-text">{{ contact.name }}</div>
</div>
